import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ChangeOrderDTO } from '../models/change-order-dto';
import { DataTablesResponse } from '../models/datatables';
import { ProductFilter, PuntoapuntoProductDTO, PuntoapuntoProductLogDTO } from '../models/puntoapunto-product-dto';


@Injectable({
  providedIn: 'root'
})

export class ProductService {

  private pathAPI = environment.urlAPI;
  private controller = "PuntoapuntoProduct/";

  constructor(private http: HttpClient) { }


  public GetPuntoapuntoProductLst(): Observable<PuntoapuntoProductDTO[]> {
    return this.http.get<PuntoapuntoProductDTO[]>(this.pathAPI + this.controller + "GetPuntoapuntoProductLst/");
  }

  public GetPuntoapuntoAllProductLst(filter: ProductFilter): Observable<PuntoapuntoProductDTO[]> {
    return this.http.post<PuntoapuntoProductDTO[]>(this.pathAPI + this.controller + "GetPuntoapuntoAllProductLst/", filter);
  }

  public get(id: string): Observable<PuntoapuntoProductDTO> {
    return this.http.get<PuntoapuntoProductDTO>(this.pathAPI + this.controller + id);
  }

  public post(data: FormData): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: FormData): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public changePublic(id: string, Status: boolean): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangePublic/' + id + '/' + Status, null);
  }

  public changePrivate(id: string, Status: boolean): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangePrivate/' + id + '/' + Status, null);
  }

  public changeOrder(data: ChangeOrderDTO[]): any {
    return this.http.post<any>(this.pathAPI + this.controller + 'ChangeOrder', data);
  }

  public getDataTable(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/', data);
  }

  public getDataTableOrder(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTableOrder/', data);
  }

  public postLog(data: PuntoapuntoProductLogDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + "InsertLog", data);
  }

}
